<div class="main-content">
  <app-header
    [title]="'COMPANY_GROUP.HEADER_TITLE' | translate"
    [subtitle]="'COMPANY_GROUP.HEADER_SUBTITLE' | translate"
  />

  <div class="row mt-5">
    <div class="col-12 d-flex justify-content-end gap-3">
      <button class="create-doc-button" [routerLink]="['/company-group', 'new']">
        {{ 'COMPANY_GROUP.CREATE_BUTTON' | translate }}
      </button>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <app-icam-container [iconName]="'company-group'" [iconColor]="'white'">
        <app-table
          [allValues$]="allCompanyGroups$"
          [type]="'company_group'"
          [hasChart]="false"
          [filters$]="emptyFilters$"
          (selectedPage)="onPageSelected($event)"
          [prevPage]="prevPage"
          [currentPage]="currentPage"
          [nextPage]="nextPage"
          [totalPages]="totalPages"
          [hasKeywordFilter]="true"
          [useInlineKeywordFilter]="false"
          [keywordFilterName]="'name'"
          [keywordFilterPlaceholder]="'COMPANY_GROUP.SEARCH_PLACEHOLDER'"
          (selectedFilter)="onFilterSelected($event)"
        />
      </app-icam-container>
    </div>
  </div>

  <div class="mt-4 mb-4">
    <app-back-button
      [linkText]="'COMPANY_GROUP.BACK_TO_USERS' | translate"
      (click)="goBack()"
    />
  </div>
</div>
<app-footer-copyright />
